import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import { isIH, sendAmplitude_Default } from '@common/utils';
import { Modal } from '@one/haven-design';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { inject } from 'mobx-react';
import { observer } from "mobx-react-lite";
import { Loader } from 'oned';
import { withRouter } from 'react-router-dom';
import './index.less';
var HowToVideo = inject(ProblemBusiness)(observer(function (props) {
    var videoURL = props.videoURL, problemCaseCadeName = props.problemCaseCadeName, videoTitle = props.videoTitle, howToVideoVisible = props.howToVideoVisible, setHowToVideoVisible = props.setHowToVideoVisible, thenAction = props.thenAction, howToVideoCreateCancelWO = props.howToVideoCreateCancelWO, history = props.history;
    var _a = useState(false), playing = _a[0], setPlaying = _a[1];
    var _b = useState(0), count = _b[0], setCount = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var getFormateSVC = function () {
        return problemCaseCadeName === null || problemCaseCadeName === void 0 ? void 0 : problemCaseCadeName.replace(/ > /g, ' -> ');
    };
    var sendWatchTimeAmplitude = function () {
        sendAmplitude_Default("Maintenance_Howtovideos_watchtime", { Time: count + " seconds" });
    };
    useEffect(function () {
        sendAmplitude_Default("Maintenance_howtovideos", { SVC: getFormateSVC() });
    }, []);
    useEffect(function () {
        var timer;
        if (playing) {
            timer = setInterval(function () {
                setCount(function (prevCount) { return prevCount + 1; });
            }, 1000);
        }
        else if (timer) {
            clearInterval(timer);
            timer = null;
        }
        return function () { return clearInterval(timer); };
    }, [playing]);
    var handlePause = function () {
        setPlaying(false);
        sendAmplitude_Default("Maintenance_Howtovideos_pause", { SVC: getFormateSVC() });
    };
    var handlePlay = function () {
        setPlaying(true);
        sendAmplitude_Default("Maintenance_Howtovideos_play", { SVC: getFormateSVC() });
    };
    var handleOk = function () {
        sendAmplitude_Default("Maintenance_Howtovideos_continuecreation", { SVC: getFormateSVC() });
        sendWatchTimeAmplitude();
        setHowToVideoVisible(false);
        thenAction();
    };
    var handleCancel = function () {
        setLoading(true);
        setPlaying(false);
        sendAmplitude_Default("Maintenance_Howtovideos_isolvedmyself", { SVC: getFormateSVC() });
        sendWatchTimeAmplitude();
        howToVideoCreateCancelWO().then(function (data) {
            history.push("/?isFromNewRequestSubmitted=true");
        }).catch(function (error) {
            window.notificationManager.show({
                title: "Warning!",
                type: "primary",
                position: "top-right",
                content: "Something was wrong, please try later!",
            });
        }).finally(function () {
            setLoading(false);
            setHowToVideoVisible(false);
        });
    };
    var handleClose = function () {
        sendWatchTimeAmplitude();
        setCount(0);
        setPlaying(function () {
            setHowToVideoVisible(false);
            return false;
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Loader, { page: true, visible: loading }),
        React.createElement(Modal, { title: videoTitle, okText: 'Continue Maintenance Request', okButtonProps: { className: isIH() ? "how-to-video-ok-ih" : "how-to-video-ok-normal" }, cancelText: 'I Solved The Issue Myself', open: howToVideoVisible, tag: "HowToVideo", width: 640, onCancel: handleCancel, __onClose: handleClose, onOk: handleOk },
            React.createElement("div", { style: { fontSize: '16px', marginBottom: '33.73px' } }, "We have a how to video for this scenario. Watch it and determine if this can solve your issue."),
            React.createElement(ReactPlayer, { controls: true, url: videoURL, height: "340px", width: "100%", onPlay: handlePlay, onPause: handlePause, playing: playing }))));
}));
export default withRouter(HowToVideo);
